import { render, staticRenderFns } from "./searchKeywordList.vue?vue&type=template&id=60e78634"
import script from "./searchKeywordList.vue?vue&type=script&lang=js"
export * from "./searchKeywordList.vue?vue&type=script&lang=js"
import style0 from "./searchKeywordList.vue?vue&type=style&index=0&id=60e78634&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e78634')) {
      api.createRecord('60e78634', component.options)
    } else {
      api.reload('60e78634', component.options)
    }
    module.hot.accept("./searchKeywordList.vue?vue&type=template&id=60e78634", function () {
      api.rerender('60e78634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/searchKeyword/searchKeywordList.vue"
export default component.exports